import { render } from "./loader.vue?vue&type=template&id=dfc22d02&lang=pug"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=dfc22d02&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__